import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconLink({
    class: cssClass,
    color
}: IconProps) {
    const strokeColor = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8.5h12M8 16.5h8M9 12.5h6" stroke={strokeColor} stroke-linecap="round"/>
        </svg>
    );
}

export default IconLink;
